(function () {
    'use strict';

    angular
        .module('app')
        .service('gtmEventsService', gtmEventsService);

    function gtmEventsService() {
        var vm = this;

        vm.startForm = startForm;
        vm.startFormTyping = startFormTyping;

        var pushFormEvent = function (formName, eventName) {
            if (!window.dataLayer) {
                console.log("window.dataLayer is undefined!");
                return;
            }

            window.dataLayer.push({
                event: eventName,
                form_title: formName
            });
        };

        var pushViewArticleEvent = function (articleName) {
            window.dataLayer.push({
                event: "view_article",
                content_title: articleName
            });
        };

        var pushLinkClickEvent = function (linkTitle, targetUrl, category) {
            window.dataLayer.push({
                event: "link_click",
                link_title: linkTitle,
                link_url: targetUrl,
                link_category: category,
                eventCallback: function () {
                    document.location = targetUrl;
                }
            });
        };

        var handleClickEvent = function (element, category) {
            var linkTitle = element.text();
            var targetUrl = element.attr('href');

            pushLinkClickEvent(linkTitle, targetUrl, category);
        };

        $(document).ready(function () {
            $(".js-ga-article").each(
                function () {
                    var articleName = $(this).data("name");
                    pushViewArticleEvent(articleName);
                });

            $('.js-ga-menu-link').click(function (e) {
                e.preventDefault();
                handleClickEvent($(this), "Menu");
            });

            $('.js-ga-footer-link').click(function (e) {
                e.preventDefault();
                handleClickEvent($(this), "Footer");
            });
        });

        function startForm(formName) {
            pushFormEvent(formName, 'form_start');
        }

        function startFormTyping(formName, contactType) {
            if (!window.dataLayer) {
                console.log("window.dataLayer is undefined!");
                return;
            }

            window.dataLayer.push({
                event: 'form_typing',
                form_title: formName,
                contact_type: contactType
            });
        }
    }
})();